import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

function topPosition(domElt) {
  if (!domElt) {
    return 0;
  }
  return domElt.offsetTop + topPosition(domElt.offsetParent);
}

class InfiniteScroll extends React.Component {
  componentDidMount() {
    this.pageLoaded = this.props.pageStart;
    this.attachScrollListener();
  }
  componentDidUpdate() {
    this.detachScrollListener();
    this.attachScrollListener();
  }
  componentWillUnmount() {
    this.detachScrollListener();
  }
  scrollListener = () => {
    const el = ReactDOM.findDOMNode(this);
    const scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    if (topPosition(el) + el.offsetHeight - scrollTop - window.innerHeight < Number(this.props.threshold)) {
      this.detachScrollListener();
      // call loadMore after detachScrollListener to allow
      // for non-async loadMore functions
      this.props.loadMore((this.pageLoaded += 1));
    }
  }
  attachScrollListener() {
    if (!this.props.hasMore) {
      return;
    }
    window.addEventListener('scroll', this.scrollListener);
    window.addEventListener('resize', this.scrollListener);
    this.scrollListener();
  }
  detachScrollListener() {
    window.removeEventListener('scroll', this.scrollListener);
    window.removeEventListener('resize', this.scrollListener);
  }
  render() {
    if (this.props.table) {
      return (
        <tbody>
          {this.props.children}
          {this.props.hasMore ? this.props.loader : null}
        </tbody>
      );  
    }
    return (
      <div className={this.props.className}>
        {this.props.children}
        {this.props.hasMore ? this.props.loader : null}
      </div>
    );
  }
}

InfiniteScroll.propTypes = {
  pageStart: PropTypes.number,
  hasMore: PropTypes.bool.isRequired,
  loadMore: PropTypes.func.isRequired,
  threshold: PropTypes.number,
  loader: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  children: PropTypes.node,
  className: PropTypes.string,
  table: PropTypes.bool,
};

InfiniteScroll.defaultProps = {
  pageStart: 0,
  hasMore: false,
  loadMore: () => {},
  threshold: 250,
  table: false,
};

export default InfiniteScroll;



// WEBPACK FOOTER //
// ./src/components/InfiniteScroll/InfiniteScroll.js